import { general } from 'src/config'

const debounceMixin = {
  computed: {
    defaultSearchDebounce () {
      return general.search_debounce
    }
  }
}

export default debounceMixin
